const cookies = require('./cookies.js');
const { nanoid } = require('nanoid');

const ANALYTICAL_COOKIE_NAME = 'analytical_id';

// Get Google Analytics client id and fill it in form
window.fillFormWithGA = () => {
  const gaClientID = ('; '+document.cookie).split('; _ga=').pop().split(';').shift();
  
  // case: cookiebanner declined
  if(window.Cookiebot.consent && window.Cookiebot.consent.marketing === false) {
    window.dataLayer.push({'google_client_id_error': 'GA1 id not sent, marketing cookies have been declined'})
  } 
  else if
  // case: _ga cookie doesn't exist (for any reason)
  (gaClientID.length === 0) {
    window.dataLayer.push({'google_client_id_error': 'GA1 id not sent, cookie does not exist'})
  }

  IdsArray = Array.prototype.slice.call(document.querySelectorAll('input[name="google_client_id"]'));
  IdsArray.forEach(input => {
    input.value = gaClientID || "";
  })

  return gaClientID;
}

// Internal analytical_id exposing
window.fillFormWithAnalyticalId = () => {
  const analyticalId = ('; '+document.cookie).split('; analytical_id=').pop().split(';').shift();
  IdsArray = Array.prototype.slice.call(document.querySelectorAll('input[name="analytical_id"]'));
  IdsArray.forEach(input => {
    input.value = analyticalId || "";
  })
}

let cookieAnalyticalId = cookies.readCookie(ANALYTICAL_COOKIE_NAME);
if (!cookieAnalyticalId || !cookieAnalyticalId.length) {
  cookieAnalyticalId = nanoid();
  cookies.setCookie(ANALYTICAL_COOKIE_NAME, cookieAnalyticalId, 365);
}

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  'analytical_id': cookieAnalyticalId,
});
